
// Skeleton Loader para simular la carga de los blogs
const SkeletonCard = () => (
  <div className="animate-pulse bg-white shadow-md rounded-lg overflow-hidden">
    <div className="h-48 bg-gray-300 w-full"></div>
    <div className="p-4">
      <div className="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
      <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
      <div className="h-4 bg-gray-300 rounded w-5/6 mb-2"></div>
      <div className="h-4 bg-gray-300 rounded w-1/2"></div>
    </div>
  </div>
);

// Función para truncar texto sin cortar palabras abruptamente
const truncateText = (text: string, maxLength: number) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength).trim() + "..." : text;
};


import { BookOpen, X, Heart } from "lucide-react";
import { BlogCard } from "../components/BlogCard";
import { useGetAllBlogs } from "../functions/blogHook";
import { useMarkBlogAsFavorite } from "../functions/blogHook"; // Importar el hook

export function BlogList() {
  const { blogs, isLoading, isError, error } = useGetAllBlogs();
  const { mutate: markAsFavorite, isLoading: isMarkingFavorite } = useMarkBlogAsFavorite();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-navy-900 text-white py-24 relative">
        <X className="w-10 h-10 absolute left-8 top-1/2 -translate-y-1/2 text-gray-300 opacity-30 hidden md:block" />
        <X className="w-10 h-10 absolute right-8 top-1/2 -translate-y-1/2 text-gray-300 opacity-30 hidden md:block" />

        <div className="container mx-auto px-6">
          <div className="flex items-center justify-center mb-6">
            <BookOpen className="w-16 h-16 text-white" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6">
            Our Blog
          </h1>
          <p className="text-center text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Dive into our collection of expert articles covering web development,
            design trends, and cutting-edge technology insights.
          </p>
        </div>
      </header>

      <main className="container mx-auto px-12 py-20">
        {isError && <p className="text-center text-red-500">Error: {error?.message}</p>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {isLoading
            ? Array(6).fill(0).map((_, index) => <SkeletonCard key={index} />) // Muestra 6 skeletons mientras carga
            : blogs?.blogs?.map((post) => (
                <div key={post._id} className="relative transition-transform duration-300 hover:scale-105">
                  <BlogCard
                    post={{
                      id: post._id,
                      title: truncateText(post.title, 50),
                      excerpt: truncateText(post.excerpt, 120),
                      readTime: `${post.readTime} min read`,
                      tag: post.tags[0] || "General",
                      image: post.images[0] || "/default-image.jpg",
                    }}
                  />
                  
                  {/* Icono de corazón para marcar como favorito */}
                  <button
                    className="absolute top-3 right-3 bg-white p-2 rounded-full shadow-lg transition-transform hover:scale-110"
                    onClick={() => markAsFavorite(post._id)}
                    disabled={isMarkingFavorite}
                  >
                    <Heart className="w-6 h-6 text-red-500" />
                  </button>
                </div>
              ))}
        </div>
      </main>
    </div>
  );
}





